module.exports = __webpack_public_path__ + "img/merge.0dd81eb0.svg";